import { StockReceiptPayload, StockSupplier } from 'types/models/StockReceipt';
import axiosInstance from './axios';
import PaginationData from 'types/models/PaginationData';
import joinURLParams from 'utils/joinUrlParams';
import { parseVenue } from './venuesServices';

const SUPPLIERS_URL = 'stock/suppliers';
export const getStockSuppliers = async (
  page?: number,
  searchTerm?: string,
  venueId?: string,
): Promise<PaginationData<StockSupplier>> => {
  const url = joinURLParams({ page, searchTerm, venueId }, SUPPLIERS_URL);
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url,
    });
    return {
      currentPage: data.current_page,
      data: parseSuppliers(data.data),
      perPage: data.per_page,
      total: data.total,
    };
  } catch (error) {
    throw error;
  }
};

export const getVenueSuppliers = async (venueId: string): Promise<StockSupplier[]> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `${SUPPLIERS_URL}?venueId=${venueId}&isActive=true&simple=true`,
    });
    return parseSuppliers(data);
  } catch (error) {
    throw error;
  }
};

export const getStockSupplier = async (id: number): Promise<StockSupplier> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `${SUPPLIERS_URL}/${id}`,
    });
    return parseSupplier(data);
  } catch (error) {
    throw error;
  }
};

export const storeStockSupplier = async (payload: StockReceiptPayload | any): Promise<StockSupplier> => {
  try {
    const { data } = await axiosInstance({
      method: 'post',
      url: SUPPLIERS_URL,
      data: payload,
    });
    return parseSupplier(data);
  } catch (error) {
    throw error;
  }
};

export const updateStockSupplier = async (id: number, payload: StockReceiptPayload | any): Promise<StockSupplier> => {
  try {
    const { data } = await axiosInstance({
      method: 'put',
      url: `${SUPPLIERS_URL}/${id}`,
      data: payload,
    });
    return parseSupplier(data);
  } catch (error) {
    throw error;
  }
};

export const deleteStockSupplier = async (id: number): Promise<StockSupplier> => {
  try {
    const { data } = await axiosInstance({
      method: 'delete',
      url: `${SUPPLIERS_URL}/${id}`,
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};

const parseSuppliers = (data: any[]): StockSupplier[] => {
  return data.map(parseSupplier);
};

const parseSupplier = (item: any): StockSupplier => {
  return {
    id: item.id,
    address: item.address,
    businessName: item.business_name,
    email: item.email,
    isActive: item.is_active,
    phone: item.phone,
    taxId: item.tax_id,
    venues: Array.isArray(item.venues) ? item.venues.map(parseVenue) : [],
  };
};
